import InfoIcon from '@/assets/images/info.svg';
import styles from './InfoAlert.module.scss';

interface Props {
  message: string;
}

const InfoAlert = ({ message }: Props) => (
  <div className={styles.alertWrapper}>
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <img src={InfoIcon} alt="Info icon" />
      </div>
      <p className={styles.message}>{message}</p>
    </div>
  </div>
);

export default InfoAlert;
